import type { CheckoutMark } from '@/lib/analytics/track';
import type { CheckoutProductId } from './types';

/** Repère « paiement lancé » des tunnels de conversion pour un product. */
export function checkoutMarkOf(productId: CheckoutProductId): CheckoutMark {
  switch (productId) {
    case 'jeraisonne_pass_normal_24h':
      return 'pass-jour';
    case 'jeraisonne_pass_normal_7d':
      return 'abonnement-semaine';
    case 'jeraisonne_pass_normal_30d':
      return 'abonnement-mois';
    case 'jeraisonne_pass_epreuves_24h':
      return 'epreuves-jour';
    case 'jeraisonne_pass_epreuves_7d':
      return 'epreuves-semaine';
    case 'jeraisonne_pass_epreuves_30d':
      return 'epreuves-mois';
    case 'jeraisonne_family_monthly':
      return 'abonnement-famille';
    case 'jeraisonne_tutor_monthly':
      return 'abonnement-prof';
    default:
      return 'abonnement-eleve';
  }
}
